
document.addEventListener('DOMContentLoaded', function () {  
  // start new-mega-menu.liquid    ********************************************
    const menuItems = document.querySelectorAll('.menu-item-new');
    const overlay = document.querySelector('.menu-overlay');
    const dropdownBar = document.getElementById('mainMenuDropdownBar');
    const dropdownInner = dropdownBar.querySelector('.dropdown-inner');
    const menuData = {};
  
    // Prepare menu data for each menu item
    menuItems.forEach((item, idx) => {
      const link = item.querySelector('a.mega-menu__link--level-1');
      const dropdown = item.querySelector('.child-menu-list');
      if (dropdown) {
        menuData[idx] = dropdown.outerHTML;
      }
      // Remove link click handler if present
      if (link) {
        link.onclick = null;
      }
      // Add click event to the whole menu item
      item.addEventListener('click', (e) => {
        // If the click is on a link and submenu exists, prevent navigation
        if (link && e.target === link && menuData[idx]) {
          e.preventDefault();
        }
        if (menuData[idx]) {
          e.stopPropagation();
          const isOpen = dropdownBar.classList.contains('active') && dropdownInner.innerHTML === menuData[idx];
          // Close all
          dropdownBar.classList.remove('active');
          dropdownInner.innerHTML = '';
          menuItems.forEach((itm) => {
            const a = itm.querySelector('a.mega-menu__link--level-1');
            if (a) a.style.opacity = '1';
          });
          if (!isOpen) {
            // Open this one
            dropdownInner.innerHTML = menuData[idx];
            dropdownBar.classList.add('active');
            menuItems.forEach((itm) => {
              const a = itm.querySelector('a.mega-menu__link--level-1');
              if (itm === item) {
                if (a) a.style.opacity = '1';
              } else {
                // if (a) a.style.opacity = '0.5';
              }
            });
            document.body.classList.add('menu-active');
          } else {
            document.body.classList.remove('menu-active');
          }
        }
        // If no submenu, allow default navigation
      });
    });

    // Close menu when clicking on overlay or anywhere outside
    overlay.addEventListener('click', () => {
      dropdownBar.classList.remove('active');
      dropdownInner.innerHTML = '';
      menuItems.forEach((itm) => {
        const a = itm.querySelector('a.mega-menu__link--level-1');
        if (a) a.style.opacity = '1';
      });
      document.body.classList.remove('menu-active');
    });

    document.addEventListener('click', (e) => {
      if (!e.target.closest('.menu-item-new')) {
        dropdownBar.classList.remove('active');
        dropdownInner.innerHTML = '';
        menuItems.forEach((itm) => {
          const a = itm.querySelector('a.mega-menu__link--level-1');
          if (a) a.style.opacity = '1';
        });
        document.body.classList.remove('menu-active');
      }
    });

    // Hide dropdown if mouse leaves the bar (optional: keep as is or remove for click-only UX)
    // if (dropdownBar) {
    //   dropdownBar.addEventListener('mouseleave', () => {
    //     dropdownInner.innerHTML = '';
    //     dropdownBar.classList.remove('active');
    //     menuItems.forEach((itm) => {
    //       const a = itm.querySelector('a.mega-menu__link--level-1');
    //       a.style.opacity = '1';
    //     });
    //   });
    // }
  // end new-mega-menu.liquid ********************************************
});